import React from 'react';
import { MainLayout, Footer } from '@/components/layout';
import MetaTags from 'react-meta-tags';
import { Card } from '@/components/uikit';

import { useTranslate } from '@/locale';
import { useHistory, useParams } from 'react-router';
import { ReactComponent as SuccessDeleteUserSvg } from '@/assets/images/success_delete_user.svg';
import { ReactComponent as FailedDeleteUserSvg } from '@/assets/images/failed-delete-user.svg';
import { ContactLifepackCare } from '@/components/common';
import classnames from 'classnames';
import LanguagePreferenceBar from '../LanguagePreferenceBar';

const resultList = ['success', 'failed'];

const svgStyle = { height: '141px', marginTop: '64px', marginBottom: '16px' };

const DeleteUserResult = () => {
  const { translate } = useTranslate();
  const { result } = useParams<{ result: string }>();
  const history = useHistory();

  if (result && !resultList.includes(result)) {
    history.replace('/patient');
  }

  const isSuccess = result === 'success';

  return (
    <MainLayout
      hideBanner
      style={{
        height: '100vh',
        marginBottom: '50px',
        backgroundColor: 'white',
      }}
    >
      <MetaTags>
        <title>Delete User</title>
      </MetaTags>
      <LanguagePreferenceBar />
      <Card>
        <div
          style={{ textAlign: 'center', margin: '24px 12px', height: '100%' }}
        >
          {isSuccess ? (
            <SuccessDeleteUserSvg style={svgStyle} />
          ) : (
            <FailedDeleteUserSvg style={svgStyle} />
          )}
          <div
            style={{
              marginBottom: '8px',
              fontSize: '18px',
              fontWeight: 500,
              color: isSuccess ? '#40B295' : '#FF4343',
            }}
          >
            {translate(
              isSuccess ? 'deleteAccountSuccess' : 'deleteAccountFailed'
            )}
          </div>
          <div
            style={{
              fontSize: '14px',
              fontWeight: 400,
              color: '#363655CC',
            }}
          >
            {translate(
              isSuccess
                ? 'accountDeletedWishGoodHealth'
                : 'problemDeleteAccountContactCS'
            )}
          </div>
        </div>
        {!isSuccess && (
          <Footer
            style={{ zIndex: 100, marginBottom: '24px' }}
            className={classnames({ 'hide-shadow': true })}
          >
            <ContactLifepackCare
              textStyle={{ color: '#363655CC' }}
              linkStyle={{ color: '#1F76FF' }}
            />
          </Footer>
        )}
      </Card>
    </MainLayout>
  );
};

export default DeleteUserResult;
